import config from 'config';
import { http_client } from './api';

const getList = async (
  page = null,
  perPage = null,
  sort = null,
  orderBy = null,
  search = null,
  jenjang_id = null,
  mapel_id = null,
  bab_id = null,
  created_by = null,
  start_date = null,
  end_date = null
) => {
  return http_client
    .get(
      config.apiUrl +
        'swm?' +
        `${perPage ? 'perPage=' + perPage : ''}` +
        `${page ? '&page=' + page : ''}` +
        `${orderBy ? '&orderBy=' + orderBy : ''}` +
        `${sort ? '&sort=' + sort : ''}` +
        `${search ? '&search=' + search : ''}` +
        `${jenjang_id ? '&jenjang_id=' + jenjang_id : ''}` +
        `${mapel_id ? '&mapel_id=' + mapel_id : ''}` +
        `${bab_id ? '&bab_id=' + bab_id : ''}` +
        `${created_by ? '&created_by=' + created_by : ''}` +
        `${start_date ? '&start_date=' + start_date : ''}` +
        `${end_date ? '&end_date=' + end_date : ''}`
    )
    .then((response) => {
      return response.data;
    });
};

const getListArchive = async (
  page = null,
  perPage = null,
  sort = null,
  orderBy = null,
  search = null,
  jenjang_id = null,
  mapel_id = null,
  bab_id = null,
  created_by = null,
  start_date = null,
  end_date = null
) => {
  return http_client
    .get(
      config.apiUrl +
        'swm/archive?' +
        `${perPage ? 'perPage=' + perPage : ''}` +
        `${page ? '&page=' + page : ''}` +
        `${orderBy ? '&orderBy=' + orderBy : ''}` +
        `${sort ? '&sort=' + sort : ''}` +
        `${search ? '&search=' + search : ''}` +
        `${jenjang_id ? '&jenjang_id=' + jenjang_id : ''}` +
        `${mapel_id ? '&mapel_id=' + mapel_id : ''}` +
        `${bab_id ? '&bab_id=' + bab_id : ''}` +
        `${created_by ? '&created_by=' + created_by : ''}` +
        `${start_date ? '&start_date=' + start_date : ''}` +
        `${end_date ? '&end_date=' + end_date : ''}`
    )
    .then((response) => {
      return response.data;
    });
};

const create = async (data) => {
  return http_client.post(config.apiUrl + 'swm', data).then((response) => {
    return response.data;
  });
};

const read = async (id) => {
  return http_client.get(config.apiUrl + 'swm/' + id).then((response) => {
    return response.data;
  });
};

const update = async (id, data) => {
  return http_client.post(config.apiUrl + 'swm/' + id, data).then((response) => {
    return response.data;
  });
};

const del = async (id) => {
  return http_client.delete(config.apiUrl + 'swm/' + id).then((response) => {
    return response.data;
  });
};

const changeStatus = async (id, data) => {
  return http_client.post(config.apiUrl + 'swm/' + id + '/status', data).then((response) => {
    return response.data;
  });
};

const getRatings = async (id, page = null, perPage = null, sort = null, orderBy = null) => {
  return http_client
    .get(
      config.apiUrl +
        'swm/' +
        id +
        '/ratings?' +
        `${perPage ? 'perPage=' + perPage : ''}` +
        `${page ? '&page=' + page : ''}` +
        `${orderBy ? '&orderBy=' + orderBy : ''}` +
        `${sort ? '&sort=' + sort : ''}`
    )
    .then((response) => {
      return response.data;
    });
};

const getHistory = async (id) => {
  return http_client.get(config.apiUrl + 'swm/' + id + '/history').then((response) => {
    return response.data;
  });
};

const getSession = async (id, sessionID) => {
  return http_client.get(config.apiUrl + 'swm/' + id + '/history/' + sessionID).then((response) => {
    return response.data;
  });
};

const getPreview = async (id, stageIdx, itemIdx) => {
  return http_client.get(config.apiUrl + 'swm/' + id + '/preview/' + stageIdx + '/' + itemIdx).then((response) => {
    return response.data;
  });
};

const storeStage = async (id, data) => {
  return http_client.post(config.apiUrl + 'swm/' + id + '/stage', data).then((response) => {
    return response.data;
  });
};

const updateStage = async (id, stageId, data) => {
  return http_client.post(config.apiUrl + 'swm/' + id + '/stage/' + stageId, data).then((response) => {
    return response.data;
  });
};

const destroyStage = async (id, stageId) => {
  return http_client.delete(config.apiUrl + 'swm/' + id + '/stage/' + stageId).then((response) => {
    return response.data;
  });
};

const storeStageItem = async (id, stageId, data) => {
  return http_client.post(config.apiUrl + 'swm/' + id + '/stage/' + stageId + '/item', data).then((response) => {
    return response.data;
  });
};

const updateStageItem = async (id, stageId, itemId, data) => {
  return http_client.post(config.apiUrl + 'swm/' + id + '/stage/' + stageId + '/item/' + itemId, data).then((response) => {
    return response.data;
  });
};

const destroyStageItem = async (id, stageId, itemId) => {
  return http_client.delete(config.apiUrl + 'swm/' + id + '/stage/' + stageId + '/item/' + itemId).then((response) => {
    return response.data;
  });
};

const getListQuestion = async (id, stageId, itemId, page = null, perPage = null, sort = null, orderBy = null, search = null) => {
  return http_client
    .get(
      config.apiUrl +
        'swm/' +
        id +
        '/stage/' +
        stageId +
        '/item/' +
        itemId +
        '/question?' +
        `${perPage ? 'perPage=' + perPage : ''}` +
        `${page ? '&page=' + page : ''}` +
        `${orderBy ? '&orderBy=' + orderBy : ''}` +
        `${sort ? '&sort=' + sort : ''}` +
        `${search ? '&search=' + search : ''}`
    )
    .then((response) => {
      return response.data;
    });
};

const addQuestion = async (id, stageId, itemId, data) => {
  return http_client.post(config.apiUrl + 'swm/' + id + '/stage/' + stageId + '/item/' + itemId + '/question', data).then((response) => {
    return response.data;
  });
};

const getQuestion = async (id, stageId, itemId, soalId) => {
  return http_client.get(config.apiUrl + 'swm/' + id + '/stage/' + stageId + '/item/' + itemId + '/question/' + soalId).then((response) => {
    return response.data;
  });
};

const updateQuestion = async (id, stageId, itemId, soalId, data) => {
  return http_client
    .post(config.apiUrl + 'swm/' + id + '/stage/' + stageId + '/item/' + itemId + '/question/' + soalId, data)
    .then((response) => {
      return response.data;
    });
};

const deleteQuestion = async (id, stageId, itemId, soalId) => {
  return http_client
    .delete(config.apiUrl + 'swm/' + id + '/stage/' + stageId + '/item/' + itemId + '/question/' + soalId)
    .then((response) => {
      return response.data;
    });
};

const SwmService = {
  getList,
  getListArchive,
  create,
  read,
  update,
  del,
  changeStatus,
  getRatings,
  getHistory,
  getSession,
  getPreview,
  storeStage,
  updateStage,
  destroyStage,
  storeStageItem,
  updateStageItem,
  destroyStageItem,
  getListQuestion,
  addQuestion,
  getQuestion,
  updateQuestion,
  deleteQuestion
};

export default SwmService;
